import { type IContent } from "@kunduz/data-access-cms-api";
import { ReactElement } from "react";
import styles from "./plainText.module.scss";

export const PlanDetailPlainText = (props: Props): ReactElement => {
  return (
    <div
      className={styles.text}
      dangerouslySetInnerHTML={{ __html: props.data.text || "" }}
    ></div>
  );
};

interface Props {
  data: IContent.PlanDetailV2AccordionData["items"][0]["items"][0]["data"];
}
